var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('h1',[_vm._v("Strona w przygotowaniu "),_c('span',{staticClass:"accent--text"},[_vm._v(" :) ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }